import type { FAQItem } from "@/lib/products";

/**
 * FAQ data for the Google Advanced Search Generator tool
 * Separated from view layer for maintainability
 */
export const googleAdvancedSearchFAQ: FAQItem[] = [
  {
    question: "How does Google Advanced Search work?",
    answer:
      "The tool provides a visual interface to build complex Google search queries without memorizing operators. You specify keywords, exact phrases, excluded words, file types, domains, date ranges, and other filters, and the tool generates a search query using Google's native operators. You can then copy it or search directly on Google.",
  },
  {
    question: "What search operators are supported?",
    answer:
      "The tool supports major Google search operators including: exact phrases (quotes), boolean logic (OR, AND, NOT), site/domain filtering (site:), file type filtering (filetype:), numeric ranges (..), language and region filters, date ranges, and location-based operators (intitle:, inurl:, intext:). All operators are formatted correctly for Google's search engine.",
  },
  {
    question: "How do I search within a specific website?",
    answer:
      "Use the 'Site or Domain' field. Enter a domain like 'nytimes.com' to search only that site, or use '.edu' to search all educational domains. The tool automatically adds the 'site:' operator. This is perfect for finding content on specific websites, academic sources, or government sites.",
  },
  {
    question: "Can I search for specific file types?",
    answer:
      "Yes! Use the 'File Type' dropdown to search for PDFs, Word documents, Excel spreadsheets, PowerPoint presentations, and more. This is extremely useful for researchers, students, and professionals who need to find documents, reports, or presentations rather than web pages.",
  },
  {
    question: "What does 'Terms Appearing' do?",
    answer:
      "This controls where your search terms must appear on the page. Options include: 'Anywhere in the page' (default), 'In the title of the page' (intitle:), 'In the text of the page' (intext:), 'In the URL of the page' (inurl:), or 'In links to the page'. This helps narrow results when you know where your keywords should be located.",
  },
  {
    question: "How do numeric ranges work?",
    answer:
      "Enter a number in 'Numbers ranging from' and 'To' to search for values within a range. For example, searching '2020..2025' finds pages containing numbers between 2020 and 2025. This is useful for finding content from specific years, prices within a range, or any numeric data within bounds.",
  },
  {
    question: "Can I filter by language and region?",
    answer:
      "Yes! Use the 'Language' dropdown to search only pages in specific languages (English, Spanish, French, etc.), and the 'Region' dropdown to prioritize results from specific countries. This is essential for finding localized content, regional information, or content in your preferred language.",
  },
  {
    question: "How do I use the generated query?",
    answer:
      "After building your search, you can copy the generated query to your clipboard and paste it into Google's search bar, or click 'Search on Google' to open Google directly with your query applied. The query uses Google's native search syntax, so it works exactly as if you typed all the operators manually.",
  },
  {
    question: "Is this tool free?",
    answer:
      "Yes, completely free with no registration required. You can build as many Google search queries as you need. There are no limits, no watermarks, and no hidden fees. It's part of our free tools collection to help researchers, students, and professionals master Google search without memorizing complex syntax.",
  },
];
